var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsVerticalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 2.33335L2.00002 2.34002M2.00002 7.00002L2.00002 7.00669M2.00002 11.6667L2.00002 11.6734M2.00002 3.00002C1.63183 3.00002 1.33335 2.70154 1.33335 2.33335C1.33335 1.96516 1.63183 1.66669 2.00002 1.66669C2.36821 1.66669 2.66669 1.96516 2.66669 2.33335C2.66669 2.70154 2.36821 3.00002 2.00002 3.00002ZM2.00002 7.66669C1.63183 7.66669 1.33335 7.36821 1.33335 7.00002C1.33335 6.63183 1.63183 6.33335 2.00002 6.33335C2.36821 6.33335 2.66669 6.63183 2.66669 7.00002C2.66669 7.36821 2.36821 7.66669 2.00002 7.66669ZM2.00002 12.3334C1.63183 12.3334 1.33335 12.0349 1.33335 11.6667C1.33335 11.2985 1.63183 11 2.00002 11C2.36821 11 2.66669 11.2985 2.66669 11.6667C2.66669 12.0349 2.36821 12.3334 2.00002 12.3334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVerticalIcon);
export default __webpack_public_path__ + "static/media/DotsVerticalIcon.41b70ac4d96a8f85454cf3910f1f4eac.svg";
export { ForwardRef as ReactComponent };